﻿import { Injectable } from "@angular/core";
import { LocalStorageService } from "angular-2-local-storage";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { AuthenticationService } from "../../../api/auth/auth.service";
import { map } from "rxjs/operators";
import { FirestoreService } from "../../../api/auth/firestore.service";
import { environment } from "../../../../../environments/environment";
import { PolicyModel } from "../../../../model/shared/policy.model";

@Injectable({
    providedIn: "root"
})
export class AuthGuard implements CanActivate {
    policies: Array<PolicyModel>;
    userPolicy: PolicyModel;

    constructor(
        private router: Router,
        private localStorageService: LocalStorageService,
        private AuthService: AuthenticationService,
        private firestoreService: FirestoreService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        const tempRoute = state.url;

        this.firestoreService.getDocument(environment.firebaseConfig.policyCollection)
            .subscribe(data => {
                this.policies = data.map(e => {
                    return {
                        ...e.payload.doc.data()
                    } as PolicyModel;
                });

                const userPolicy = this.policies.find(f => f.userEmail === this.localStorageService.get<string>("userEmail"));
                if (userPolicy === undefined) {
                    this.localStorageService.clearAll();
                    this.router.navigate(["/login"], { queryParams: { tempUrl: tempRoute } });

                    return false;
                } else {
                    if (this.localStorageService.get("accessToken")) {
                        return true;
                    } else {
                        if (tempRoute === "/login") {
                            this.router.navigate(["/login"]);

                            return true;
                        } else {
                            this.router.navigate(["/login"], { queryParams: { tempUrl: tempRoute } });

                            return false;
                        }
                    }
                }
            });

        return true;
    }
}
